import { render, staticRenderFns } from "./SVG-Eye.vue?vue&type=template&id=23d81ac6&lang=pug&"
import script from "./SVG-Eye.vue?vue&type=script&lang=js&"
export * from "./SVG-Eye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports